import { UUID } from "@bitory-gmbh/nidavellir";
import { useHtzSummaryShowQuery } from "@/services/backend/htz/summary/api/summary-api";

/**
 * useSummaryItemReport resolves the report summarized by an item of a
 * summary. A report is reached through the item of a summary, so callers
 * identify the item and not the report.
 *
 * `notFound` is set once the summary is loaded but holds no item with the
 * requested id, e.g. after the item was removed.
 */
export function useSummaryItemReport(summaryId: UUID, itemId: UUID) {
  const {
    data: summary,
    isLoading,
    error,
  } = useHtzSummaryShowQuery({ id: summaryId });

  const item = summary?.items.find((i) => i.id === itemId);

  return {
    summary,
    item,
    reportId: item?.reportId,
    isLoading,
    error,
    notFound: summary !== undefined && item === undefined,
  };
}
